import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { MarketplaceSection, MarketplaceChart, MarketplaceReport, IndexWrapper, ServiceType } from "@framework/shared";

import { MarketplaceRarity } from "./rarity";
import { MarketplaceDiscrete } from "./discrete";

export const marketRoutes: Array<RouteObject> = [
  {
    path: "/marketplace",
    element: <Protected />,
    children: [
      {
        index: true,
        element: <Navigate to="/marketplace/report" />,
      },
      {
        path: "/marketplace/report",
        children: [
          {
            index: true,
            element: (
              <IndexWrapper index="marketplace">
                <MarketplaceSection service={ServiceType.ADMIN} />
              </IndexWrapper>
            ),
          },
          { path: "/marketplace/report/search", element: <MarketplaceReport service={ServiceType.ADMIN} /> },
          { path: "/marketplace/report/chart", element: <MarketplaceChart service={ServiceType.ADMIN} /> },
          { path: "/marketplace/report/rarity", element: <MarketplaceRarity /> },
          { path: "/marketplace/report/discrete", element: <MarketplaceDiscrete /> },
        ],
      },
    ],
  },
];
